<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title">Данные Выгодоприобретателя<br class="onlydesk"> (Застрахованного лица)</h3>
      <Step4Block :class="{'step4block-additional': index}" ref="benefi" :active="active" v-for="(b, index) in beneficiaries" :key="b.key"
        :index="index"  
        @setCopy="Step4BlockCopied = $event"
        :copyEnabled="!Step4BlockCopied"
        @filledChanged="filledBeneficiaries[index] = $event" 
        @dataChanged="setBenificiary(index, $event)">
          <div class="step4block-additional__close" v-if="index" @click="removeBeneficiary(index)">
            <svg viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.96875 9.46387L24.0016 24.4967" stroke="#5B5D6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.96875 24.5361L24.0016 9.50328" stroke="#5B5D6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </Step4Block>
      <AddBtn class="step4__addbutton" @click="addBeneficiary">Указать еще одного Выгодоприобретателя (наследника)</AddBtn>
      <div class="step__line"></div>
      <Btn class="step__next" :disabled="!filled" @click="toNext">Далее</Btn>
    </div>
    </div>
</template>

<script>
import Btn from '../Btn.vue';
import AddBtn from '../AddBtn.vue';
import Step4Block from './Step4Block.vue';
import { mapState } from 'vuex';
import nameSuggest from '../../mixins/nameSuggest';
export default {
  props: {
    active: { type: Boolean, default: false }
  },
  mixins: [nameSuggest],
  data: ()=>({
    Step4BlockCopied: false,
    errors: {},
    beneficiaries: [ { key: 1 } ],
    filledBeneficiaries: [ false ],
    key: 2
  }),
  components: { Step4Block, Btn, AddBtn },
  methods: {
    setBenificiary(index, data) {
      this.beneficiaries[index] = { ...data, key: this.beneficiaries[index].key}
    },
    addBeneficiary() {
      this.filledBeneficiaries.push(false)
      this.beneficiaries.push({key: this.key++})
    },
    removeBeneficiary(index) {
      this.filledBeneficiaries = this.filledBeneficiaries.filter((el,i) => i != index)
      this.beneficiaries = this.beneficiaries.filter((el,i) => i != index)
    },
    toNext(){
      this.$store.commit('setBeneficiaries', this.beneficiaries)
      this.$store.commit('nextStep')
    },
  },
  computed: {
    ...mapState(['form']),
    filled(){
      for (let key in this.errors)
        if (this.errors[key]) return false
      if (this.filledBeneficiaries.includes(false)) return false
      return true
    }
  },
}
</script>

<style lang="sass">
.step4__addbutton
  width: 585px
  max-width: 100%
  @include for-mob
    .addbtn__text
      text-align: left
</style>